export const ADD_WISH = 'ADD_WISH';
export const ADD_HEART = 'ADD_HEART';
export const PLUS_HEART = 'PLUS_HEART';
export const WISHES_LOADING = 'WISHES_LOADING';
export const WISHES_FAILED = 'WISHES_FAILED';
export const SHOW_WISHES = 'SHOW_WISHES';
